import React from 'react';
import { useNavigate } from 'react-router-dom';
import { manu1, manu2, manu3, manu4, powm1, powm2, powm3, powm4, powm5, powm6, powm7, ta1, ta2, ta3, ta4, ta5, ta6, ta7, ua1, ua2, ua3, ua4, ua5, ua6, ua7 } from '../../MediaConstant';
import Footer from '../../Reuseable Components/Footer';
import Header from '../../Reuseable Components/Header';
import HeaderInner from '../../Reuseable Components/HeaderInner';
import TopFooterCollage from '../../Reuseable Components/TopFooterCollage';
import Slider from 'react-slick/lib/slider';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

const YourPower3b = () => {
    let navigate = useNavigate();

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className='power3-next'
                // style={{ ...style, display: "block", background: "red", height: "80px", width: "80px" }}
                onClick={onClick}
            />
        );
    }

    function SamplePrevArrow(props) {
        const { style, onClick } = props;
        return (
            <div
                className="power3-prev"
                // style={{ ...style, display: "block", background: "green", height: "80px", width: "80px" }}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        appendDots: dots => (
            <div
                style={{
                    // backgroundColor: "black",
                    borderRadius: "10px",
                    color: "white",
                    padding: "10px"
                }}
            >
                <ul style={{ margin: "0px" }}> <span style={{ color: "white" }}>{dots}</span> </ul>
            </div>
        ),
    };

    return (
        <div className="common_bg_back Your_Power ">
            <Header />
            <HeaderInner props={"Your Power"} />
            <div className='Your_Power_content'>
                <div className='container'>
                    <div className="row">
                        <div className="offset-lg-3 col-lg-6">
                            <div class="maindiv_lambiline">
                                <div class="lambi_line"></div>
                                <div class="flx_stepsboxes">
                                    <div className="box-wdth">
                                        <p class="bx-noactive">01</p>
                                        <p class="step1">Assesment</p>
                                    </div>
                                    <div className="box-wdth">
                                        <p class="bx-noactive">02</p>
                                        <p class="step1">Choose Your Power</p>
                                    </div>
                                    <div className="box-wdth">
                                        <p class="bx-active">03</p>
                                        <p class="step1">Select Your Plan</p>
                                    </div>
                                    <div className="box-wdth">
                                        <p class="bx-noactive">04</p>
                                        <p class="step1">Checkout</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container'>
                    <div className="row">
                        <div className="offset-lg-3 col-lg-6">
                            <div class="maindiv_lambiline pos-rel pt-3">
                                <Slider {...settings} className="slider_top_home">
                                    <div className='actv_brwn'>
                                        <p className='mb-0'>
                                            Fri
                                        </p>
                                        <p>
                                            Dec 10
                                        </p>
                                    </div>
                                    <div className='noactv_brwn'>
                                        <p className='mb-0'>
                                            Sat
                                        </p>
                                        <p>
                                            Dec 11
                                        </p>
                                    </div>
                                    <div className='noactv_brwn'>
                                        <p className='mb-0'>
                                            Sun
                                        </p>
                                        <p>
                                            Dec 12
                                        </p>
                                    </div>
                                    <div className='noactv_brwn'>
                                        <p className='mb-0'>
                                            Mon
                                        </p>
                                        <p>
                                            Dec 13
                                        </p>
                                    </div>
                                    <div className='noactv_brwn'>
                                        <p className='mb-0'>
                                            Tues
                                        </p>
                                        <p>
                                            Dec 14
                                        </p>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='gry_sec_power'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <p className='menu_for_txt mb-0'>Menu for Fri, 10 Dec</p>
                                <p className='menu_for_box'>Add to Box</p>
                            </div>
                            <div className='col-lg-6 text-right'>
                                <button className='btn btn-light bt-brwn px-5'>SAVE</button>
                            </div>
                            <div className='col-lg-12 mb-0'>
                                <div className='line_gry_light mb-3'>

                                </div>
                            </div>
                            <div className='col-lg-4 px-4 text-center my-4'>
                                <img src={ua1} className="img_powm" />
                                <p className='top_heading_crd mt-4'>Yogurt Spread</p>
                                <p className='top_cont_crd'>Pickled eggplant / walnuts / za’atar / butterflap bread</p>
                                <p className='top_heading_crd'>$7.00</p>
                                <div>
                                    <div className='del_btn_pow'>
                                        <span className='del_ico'>
                                            <DeleteSweepIcon />
                                        </span>
                                        <button className='btn btn-light bt-brwn py-cus-poww'>Add to box</button>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-4 px-4 text-center my-4 '>
                                <img src={ua2} className="img_powm" />
                                <p className='top_heading_crd mt-4'>Beet Hummus</p>
                                <p className='top_cont_crd'>Beets / garlic / tahini / roasted pumpkin seeds  / rosemary infused oil</p>
                                <p className='top_heading_crd'>$ 5.00</p>
                                <div className='del_btn_pow'>
                                    <span className='del_ico'>
                                        <DeleteSweepIcon />
                                    </span>
                                    <button className='btn btn-light bt-brwn py-cus-poww'>Add to box</button>
                                </div>
                            </div>
                            <div className='col-lg-4 px-4 text-center my-4'>
                                <img src={ua3} className="img_powm" />
                                <p className='top_heading_crd mt-4'>Gluten Free Lasagna </p>
                                <p className='top_cont_crd'>Authentic 20 years in the making lasagna with three sauces bolognese / marinara / bechamel</p>
                                <p className='top_heading_crd'>$ 16.00</p>
                                <div className='del_btn_pow'>
                                    <span className='del_ico'>
                                        <DeleteSweepIcon />
                                    </span>
                                    <button className='btn btn-light bt-brwn py-cus-poww'>Add to box</button>
                                </div>
                            </div>
                            <div className='col-lg-4 px-4 text-center my-4'>
                                <img src={ua4} className="img_powm" />
                                <p className='top_heading_crd mt-4'>Green Coffee “Pure
                                    Awakening"</p>
                                <p className='top_cont_crd'>Unroasted coffee / cardamom / served with a stuffed date</p>
                                <p className='top_heading_crd'>$ 6.00</p>
                                <div className='del_btn_pow'>
                                    <span className='del_ico'>
                                        <DeleteSweepIcon />
                                    </span>
                                    <button className='btn btn-light bt-brwn py-cus-poww'>Add to box</button>
                                </div>
                            </div>
                            <div className='col-lg-4 px-4 text-center my-4'>
                                <img src={ua5} className="img_powm" />
                                <p className='top_heading_crd mt-4'>Blueberry
                                    Parfait</p>
                                <p className='top_cont_crd'>Rice pudding / pumpkin seed / blueberry chocolate sauce</p>
                                <p className='top_heading_crd'>$ 6.00</p>
                                <div className='del_btn_pow'>
                                    <span className='del_ico'>
                                        <DeleteSweepIcon />
                                    </span>
                                    <button className='btn btn-light bt-brwn py-cus-poww'>Add to box</button>
                                </div>
                            </div>
                            <div className='col-lg-4 px-4 text-center my-4'>
                                <img src={ua6} className="img_powm" />
                                <p className='top_heading_crd mt-4'>Almond
                                    Lemonade</p>
                                <p className='top_cont_crd'>A perfect mix of lemon & almond refresher</p>
                                <p className='top_heading_crd'>$ 4.00</p>
                                <div className='del_btn_pow'>
                                    <span className='del_ico'>
                                        <DeleteSweepIcon />
                                    </span>
                                    <button className='btn btn-light bt-brwn py-cus-poww'>Add to box</button>
                                </div>
                            </div>
                            <div className='col-lg-4 px-4 text-center my-4'>

                            </div>
                            <div className='col-lg-4 px-4 text-center my-4'>
                                <img src={ua7} className="img_powm" />
                                <p className='top_heading_crd mt-4'>Blueberry Quinoa
                                    Porridge</p>
                                <p className='top_cont_crd'>Date molasses / pumpkin seeds /  rose water / creme fresh</p>
                                <p className='top_heading_crd'>$ 10.00</p>
                                <div className='del_btn_pow'>
                                    <span className='del_ico'>
                                        <DeleteSweepIcon />
                                    </span>
                                    <button className='btn btn-light bt-brwn py-cus-poww'>Add to box</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <TopFooterCollage />
                <Footer />
            </div>
        </div>
    )
};

export default YourPower3b;